export default __webpack_public_path__ + "static/media/icon_like.9f912eed.svg";